import { Separator } from '@repo/shared-client/components/ui'
import { createFileRoute } from '@tanstack/react-router'
import { PaymentsPendingStat } from '@web/src/features/admin/admin-payments/payments-pending-stat'
import MetricStat from '@web/src/features/admin/metric-stat/metric-stat'
import ActiveUsersMetricsChart from '@web/src/features/admin/metrics-chart/active-users-metrics-chart'
import MediaTotalsMetricsChart from '@web/src/features/admin/metrics-chart/media-totals-metrics-chart'
import MetricsChart from '@web/src/features/admin/metrics-chart/metrics-chart'
import { env } from '@web/src/lib/env.client'
import { useTranslation } from '@web/src/lib/intl/react'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'

export const Route = createFileRoute('/(auth)/(admin-layout)/admin/dashboard')({
  component: DashboardPage,
  head: () =>
    seo({
      title: `Admin - Dashboard | ${env.VITE_APP_NAME}`,
      description: 'Admin Dashboard Page',
      robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
    }),
})

function DashboardPage() {
  const { t } = useTranslation()

  return (
    <div className="mx-auto w-full max-w-screen-xl py-6">
      <h1 className="mb-6 font-semibold text-2xl tracking-tight">{t('Admin Dashboard')}</h1>

      <h2 className="mb-4 font-medium text-lg">{t('Key Metrics')}</h2>
      <div className="mb-8 grid grid-cols-2 gap-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6">
        <MetricStat name="TOTAL_USERS" title={t('Total Users')} />
        <MetricStat name="ACTIVE_USERS" title={t('Daily Active Users')} />
        <MetricStat name="ACTIVE_USERS_WEEKLY" title={t('Weekly Active Users')} />
        <MetricStat name="ACTIVE_USERS_MONTHLY" title={t('Monthly Active Users')} />

        <MetricStat name="MEDIA_VIDEO_TOTAL" title={t('Total Media Videos')} />
        <MetricStat name="MEDIA_IMAGE_TOTAL" title={t('Total Media Images')} />
        <MetricStat name="ATTACHED_MEDIA_IMAGE_TOTAL" title={t('Total Attached Images')} />
        <MetricStat name="ATTACHED_MEDIA_VIDEO_TOTAL" title={t('Total Attached Videos')} />

        <MetricStat name="MESSAGES_TOTAL" title={t('Total Messages')} />
        <MetricStat name="MESSAGES_SENT_LAST_DAY" title={t('Messages (24h)')} />

        <MetricStat name="PLACES_TOTAL" title={t('Total Places')} />
        <MetricStat name="PUBLICATIONS_TOTAL" title={t('Total Publications')} />

        <MetricStat name="REPORTS_TOTAL" title={t('Total Reports')} />
        <MetricStat name="OPEN_REPORTS_TOTAL" title={t('Open Reports')} />
        <PaymentsPendingStat />
      </div>

      <Separator className="my-8 w-full" />

      <h2 className="mb-4 font-medium text-lg">{t('Trend Analysis')}</h2>
      <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
        <MetricsChart cardClassName="h-[400px]" name="TOTAL_USERS" title={t('Total Users')} />
        <ActiveUsersMetricsChart cardClassName="h-[400px]" title={t('Active users')} />

        <MetricsChart cardClassName="h-[400px]" name="NEW_USERS" title={t('New Users')} />

        <MetricsChart cardClassName="h-[400px]" name="LOST_USERS" title={t('Users Deleting Accounts')} />

        <MediaTotalsMetricsChart cardClassName="h-[400px]" title={t('Total images & videos')} />
      </div>
    </div>
  )
}
